import React from "react";
import { Button } from "@/components/ui/button";
import { Mic, Square } from "lucide-react";
import { cn } from "@/lib/utils";

interface AudioControlsProps {
  isListening: boolean;
  onToggleListening: () => void;
  disabled?: boolean;
}

export const AudioControls: React.FC<AudioControlsProps> = ({
  isListening,
  onToggleListening,
  disabled
}) => {
  return (
    <div className="flex justify-center items-center py-4 md:py-6">
      <div className="relative">
        {isListening && (
          <>
            <div className="absolute inset-0 bg-red-500/20 rounded-full animate-ping" />
            <div className="absolute inset-0 bg-red-500/30 rounded-full animate-pulse scale-125" />
          </>
        )}
        <Button
          type="button"
          onClick={onToggleListening}
          disabled={disabled}
          size="icon"
          className={cn(
            "relative h-16 w-16 md:h-20 md:w-20 rounded-full shadow-lg transition-all duration-300 hover:scale-105 active:scale-95",
            isListening
              ? "bg-red-500 hover:bg-red-600 ring-4 ring-red-100"
              : "bg-[#d769b3] hover:bg-[#c558a1] ring-4 ring-pink-50"
          )}
        >
          {isListening ? (
            <Square className="h-6 w-6 md:h-8 md:w-8 text-white fill-white" />
          ) : (
            <Mic className="h-6 w-6 md:h-8 md:w-8 text-white" />
          )}
        </Button>
      </div>
    </div>
  );
};
